import { call, put, takeLatest } from 'redux-saga/effects';
import { getErrorMessageFromAPI } from '../../utilz';
import { setAppLoader } from '../common/CommonActions';
import {
  getShipmentInfoListInSuccess,
  getShipmentInfoListListInFail,
  saveShipmenOtherDetailsInFail,
} from './POShipmentSearchActions';
import { getShipmentInfoService, saveShipmentOtherDetailsService } from './POShipmentSearchEffects';
import POShipmentSearchType from './POShipmentSearchTypes';

function* getShipmentInfoAction(req) {
  try {
    const { data } = yield call(getShipmentInfoService, req.payload);
    yield put(getShipmentInfoListInSuccess({ data: data }));
  } catch (e) {
    yield put(getShipmentInfoListListInFail({ message: getErrorMessageFromAPI(e) }));
  }
}

function* saveShipmentOtherDetailsAction(req) {
  try {
    yield call(saveShipmentOtherDetailsService, req.payload);
    yield put(setAppLoader(false));
  } catch (e) {
    yield put(saveShipmenOtherDetailsInFail({ message: getErrorMessageFromAPI(e) }));
    yield put(setAppLoader(false));
  }
}

export default function* POShipmentSearchSaga() {
  yield takeLatest(POShipmentSearchType.GET_SHIPMENT_INFO_LIST, getShipmentInfoAction);
  yield takeLatest(POShipmentSearchType.SAVE_SHIPMENT_OTHER_DETAILS_PROGRESS, saveShipmentOtherDetailsAction);
}
